var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.6 83.2A89.6 89.6 0 0 0 38.4 128M16 105.6 38.4 128 60.8 105.6M50.4 172.8A89.6 89.6 0 0 0 217.6 128M195.2 150.4 217.6 128 240 150.4M152 108c0-11-10.7-20-24-20s-24 9-24 20 10.7 20 24 20 24 9 24 20-10.7 20-24 20-24-9-24-20M128 68v20M128 168v20",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.916a67f264375474b0be20a05f25655d.svg";
export { ForwardRef as ReactComponent };